import { useState } from 'react';
import CalculatePriceForCaravanStep from './caravan/CalculatePriceForCaravanStep';
import WhichUvpShouldWeInsureStep from './WhichUvpShouldWeInsureStep';
import CalculatePriceForTrailerStep from './trailer/CalculatePriceForTrailerStep';
import { useRecoilValue } from 'recoil';
import { currentOnsaCoverableSelector } from '../../../../recoil/selectors/currentOnsaCoverableSelector';
import type {
    CaravanOnsaDTO,
    TrailerOnsaDTO
} from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa/uvp';

type UvpRegStepVariant = 'regNumber' | 'noRegNumber';

const regNumberComponentMap = {
    caravan: CalculatePriceForCaravanStep,
    trailer: CalculatePriceForTrailerStep
};

const UvpRegOrNoRegNumberStep = ({
    goNext,
    goPrevious,
    flavour
}: {
    goNext: () => void;
    goPrevious: () => void;
    flavour: keyof typeof regNumberComponentMap;
}): React.JSX.Element => {
    const coverable = useRecoilValue<CaravanOnsaDTO | TrailerOnsaDTO>(currentOnsaCoverableSelector);
    const [stepVariant, setStepVariant] = useState<UvpRegStepVariant>(() => {
        const { regNumber, make, model, year } = coverable;
        if (!regNumber && make && model && year) return 'noRegNumber';
        return 'regNumber';
    });

    const stepProps = { goNext, goPrevious };
    const RegNumberComponent = regNumberComponentMap[flavour];
    if (stepVariant === 'regNumber') {
        return (
            <RegNumberComponent
                {...stepProps}
                renderNoRegNumberPage={() => {
                    setStepVariant('noRegNumber');
                }}
            />
        );
    }
    if (stepVariant === 'noRegNumber') {
        return (
            <WhichUvpShouldWeInsureStep
                {...stepProps}
                renderRegNumberPage={() => {
                    setStepVariant('regNumber');
                }}
            />
        );
    }
    return <></>;
};

const CaravanRegOrNoRegNumberStep = ({
    goNext,
    goPrevious
}: {
    goNext: () => void;
    goPrevious: () => void;
}): React.JSX.Element => {
    return <UvpRegOrNoRegNumberStep goNext={goNext} goPrevious={goPrevious} flavour="caravan" />;
};

const TrailerRegOrNoRegNumberStep = ({
    goNext,
    goPrevious
}: {
    goNext: () => void;
    goPrevious: () => void;
}): React.JSX.Element => {
    return <UvpRegOrNoRegNumberStep goNext={goNext} goPrevious={goPrevious} flavour="trailer" />;
};

export { CaravanRegOrNoRegNumberStep, TrailerRegOrNoRegNumberStep };
